<template>
    <div style="width: 100%;height:100%;padding-bottom: 80px;position: absolute">
        <img :src="referURL" width="100%" />
        <p :style="{ color: fontColor, marginLeft: marginLeft+'px' }" style="position: absolute;left:0px;bottom: 0px;text-decoration: underline;text-align: center;">{{ linkURL }}</p>
        <p :style="{ color: fontColor, borderColor: fontColor }" style="width: 100px;position: absolute;margin-left: calc(50% - 50px);text-align:center;bottom: -50px;font-weight: bold;border:2px solid">copy</p>
    </div>
    
</template>

<script>

export default {
    props: ['btn','dev'],
    computed: {
        siteURL () { return this.$store.state.client.siteURL },
        fontColor () { return this.$store.state.client.fontColor }
    },
    data () {
        return {
            baseURL: "https://api.survey-vip.com/qr?id=",
            linkURL: '',
            referURL: '',
            marginLeft: 0
        }
    },
    mounted () {
        this.linkURL = 'https://'+this.siteURL+'/refer/demolink'
        this.referURL = this.baseURL+encodeURIComponent(this.linkURL);
        this.$nextTick(() => {
            var cWidth = parseInt(getComputedStyle(this.$el.parentElement).width);
            var pWidth = parseInt(getComputedStyle(this.$el.querySelector('p')).width);
            this.marginLeft = - ( cWidth - pWidth ) / 2
            console.log({
                cWidth,
                pWidth,
                marginLeft: this.marginLeft
            });
            this.$forceUpdate();
         })

    }
}    
</script>
